const reasons = [
  {
    icon: 'ri-user-heart-line',
    title: 'Zero Experience Needed',
    description: 'Total beginner? Perfect. Every class is designed to meet you exactly where you are — no prep, no judgment.',
    accentColor: '#ff4322',
  },
  {
    icon: 'ri-lightbulb-flash-line',
    title: 'Guided by Kelsey',
    description: 'The studio\'s founder personally leads every session with genuine energy, patience, and contagious creativity.',
    accentColor: '#ffb300',
  },
  {
    icon: 'ri-tools-line',
    title: 'Everything Included',
    description: 'Canvas, paints, brushes, and all materials are provided. Just walk in ready to create.',
    accentColor: '#ff7120',
  },
  {
    icon: 'ri-home-smile-2-line',
    title: 'Judgment-Free Zone',
    description: 'Art Den is built for joy. Whether solo, with friends, or celebrating — it\'s always a warm, welcoming space.',
    accentColor: '#e0285a',
  },
  {
    icon: 'ri-price-tag-3-line',
    title: 'Flexible for Any Group',
    description: 'Drop-in classes, private parties, corporate groups, and gift cards — an experience for every occasion.',
    accentColor: '#ff4322',
  },
  {
    icon: 'ri-map-pin-2-line',
    title: 'Right in Nazareth, PA',
    description: 'Conveniently located at 37 E Belvidere Street — easily accessible from across the Lehigh Valley.',
    accentColor: '#ffb300',
  },
];

const WhyChooseUs = () => {
  return (
    <section className="py-20 md:py-28 relative overflow-hidden" style={{ background: '#f6f1eb' }}>
      {/* Background paint splash */}
      <div className="absolute top-0 right-0 w-80 h-80 pointer-events-none" style={{ background: 'radial-gradient(ellipse, rgba(255,67,34,0.06) 0%, transparent 70%)', borderRadius: '60% 40% 70% 30% / 50% 60% 40% 50%' }} />

      <div className="max-w-7xl mx-auto px-4 md:px-8 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16">

          {/* Left — heading + image */}
          <div className="lg:col-span-5">
            <div className="flex items-center gap-3 mb-5">
              <div className="h-px w-8 bg-artden-coral" />
              <span className="section-label">Why Art Den Studio</span>
            </div>
            <h2 className="font-cormorant font-medium text-artden-dark leading-[1.0] tracking-tight mb-6" style={{ fontSize: 'clamp(2.5rem, 4.5vw, 4rem)' }}>
              Designed<br />
              With Heart.<br />
              <em className="font-light italic text-artden-coral">Taught With Joy.</em>
            </h2>
            <p className="font-outfit text-artden-mid text-base leading-relaxed mb-8 max-w-sm">
              Art Den Studio is more than a class — it's a creative community in Nazareth, PA where every person leaves genuinely proud of what they made.
            </p>

            {/* Owner image + quote */}
            <div className="relative rounded-2xl overflow-hidden" style={{ height: '280px' }}>
              <img
                src="https://public.readdy.ai/ai/img_res/18a483cf30087771454367f0bc3fe59d.jpg"
                alt="Kelsey teaching at Art Den Studio"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0" style={{ background: 'linear-gradient(to top, rgba(8,8,8,0.75) 0%, transparent 55%)' }} />
              <div className="absolute bottom-0 left-0 right-0 p-6">
                <blockquote className="font-cormorant text-lg text-white font-light italic leading-snug">
                  "I want this to be the place where people come to escape and explore their creativity — with no worries."
                </blockquote>
                <p className="font-outfit text-artden-coral text-xs font-bold tracking-widest uppercase mt-2">— Kelsey, Founder</p>
              </div>
            </div>
          </div>

          {/* Right — reasons */}
          <div className="lg:col-span-7 flex flex-col gap-3">
            {reasons.map((reason, i) => (
              <div
                key={i}
                className="flex gap-4 p-5 rounded-xl border border-artden-canvas bg-white/70 hover:bg-white hover:border-artden-coral/30 transition-all duration-200 group cursor-default"
              >
                <div
                  className="shrink-0 w-10 h-10 flex items-center justify-center rounded-xl"
                  style={{ background: `${reason.accentColor}12`, border: `1px solid ${reason.accentColor}25` }}
                >
                  <i className={`${reason.icon} text-lg`} style={{ color: reason.accentColor }}></i>
                </div>
                <div>
                  <h3 className="font-cormorant text-xl font-semibold text-artden-dark mb-1">{reason.title}</h3>
                  <p className="font-outfit text-artden-mid text-sm leading-relaxed">{reason.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
